// extracted by mini-css-extract-plugin
export default {"customSweetAlert":"style_customSweetAlert__Ea0xR","customSweetAlertTitle":"style_customSweetAlertTitle__ln0bA","customSweetAlertContent":"style_customSweetAlertContent__0XeSC"};